import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSeo } from '../hooks/useSeo';

const KNOWN_STATUSES = ['success', 'pending', 'failure'];

export default function CheckoutResultPage() {
  const [searchParams] = useSearchParams();
  const { t } = useTranslation();
  const status = searchParams.get('status');
  const key = KNOWN_STATUSES.includes(status) ? status : 'default';
  const message = t(`checkoutResult.${key}`, { returnObjects: true });

  useSeo({
    title: `${message.title} | Eduardo Passos`,
    description: message.body,
    path: '/projects/websites/result',
    noindex: true,
  });

  return (
    <section className="section checkout-result in-view">
      <div className="section__container checkout-result__inner">
        <h2 className="section__title">{message.title}</h2>
        <p className="checkout-result__text">{message.body}</p>
        <Link to="/" className="btn btn--outline">{t('checkoutResult.backToHome')}</Link>
      </div>
    </section>
  );
}
